import React, { PropTypes, Component } from 'react'
import { translate } from 'react-i18next'

class Favorite extends Component {
  constructor (props) {
    super(props)
    this.propertyDetails = this.propertyDetails.bind(this)
  }

  propertyDetails (id) {
    this.props.router.push('/property/' + id)
  }

  render () {
    const { user, children } = this.props
    return (
      <section>
        {children &&
          React.cloneElement(children, {
            user,
            propertyDetails: this.propertyDetails
          })}
      </section>
    )
  }
}

Favorite.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node,
  router: PropTypes.object
}

export default translate([ 'common', 'favorite' ], { wait: true })(Favorite)



// WEBPACK FOOTER //
// ./src/pages/Favorite/index.js